import { version } from './version.js';
export const getVersion = () => `@ensdomains/ensjs@${version}`;
//# sourceMappingURL=error-utils.js.map